import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "react-accessible-accordion/dist/fancy-example.css";
import Util from "../../../Common/util";
import API from "../../../Common/api";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import * as FileSaver from 'file-saver';
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Alert from "reactstrap/lib/Alert";
//import styled, { css } from "styled-components";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'

var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr = [];
var unassign_arr = [];
var data_type = "";
const Heading = [['Unique Id',  'Facility Code',  'PTL Id', 'Order Number', 'Retailer Code',  'Hul Code', 'Order Date', 'Sequence No',  'Jarvis Product Id', 'Base Pack Code',  'Cbu Code', 'SKU7 code',  'Product Name', 'PKD',  'MRP',  'UPC',  'ICLD Ean', 'Loose Ean',  'ICLD Qty', 'Loose Qty']];



class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.getCookie = this.getCookie.bind(this);

    this.accessCookie = this.accessCookie.bind(this);
    this.toggle = this.toggle.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.UnAssign = this.UnAssign.bind(this);
    this.assignedOrdersList = this.assignedOrdersList.bind(this);
    this.Assign = this.Assign.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);

    this.state = {
      orderdata: [],
      variant_data: [],
      shelf_life_uom: [],
      ShowpopupLoader: false,
      showFilter: false,
      ShowConfirmLoader: false,
      stationType: [],
      stationStatus: [],
      unAssignOrder: [],
      assignOrder: [],
      filtered_orderData : "",
      isDisabledSearch: false,
      showConfirmError: false,
      group_id: "",
      selectedOutlet: "",
      selectedDistributor: "",
      selectedLocation: "",
      selectedOrder: "",
      order: [],
      row_data: [],
      arr_data: [],
      store: [],
      subStore: [],
      distributor: [],
      outlet: [],
      location: [],
      EditModal: false,
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      showTable: false,
      status_type: "1",
      apply: true,
      store_id: "",
      sub_store_id: "",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      request_id: "",
      showUnAssignedOrder: false,
      showFetchDispatchData: false,
      isChecked: false,
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      apply1: true,
      total_value: "",
      total_quantity: "",
      modal: false,
      selectedGroup: "",
      selectedSubGroup: "",
      modal1: false,
      modal2: false,
      modalFailed: false,
      showAllItem: false,
      disabledReasonBtn: true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
    };
  }

  Assign() {
    this.fetchDispatch();
  }
  onGroupChange = (evt) => {
    this.setState({
      group_id: evt.target.value.trim(),
    });
  };
  UnAssign() {
    this.setState({
      loading_overlay: true,
    });
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/product/product_master/v1/orders/", { param: payload })
      .then((response) => {
        console.log(response.data.data.unassigned_orders);
        this.setState({
          showUnAssignedOrder: false,
          showAssignedOrder: true,
          unAssignOrder: response.data.data.unassigned_orders,
          assignOrder: response.data.data.assigned_orders,
          loading_overlay: false,
        });
      })
      .catch(function (error) {});
  }

  assignedOrdersList() {
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/product/product_master/v1/orders/", { param: payload })
      .then((response) => {
        console.log(response.data.data.unassigned_orders);
        this.setState({
          unAssignOrder: response.data.data.unassigned_orders,
          assignOrder: response.data.data.assigned_orders,
        });
      })
      .catch(function (error) {});
  }

  AssignData() {
    this.setState({
      assignLoader: true,
      assignDisabled: true,
    });
    console.log("this.state.arr_data", this.state.arr_data);
    var arrayData = this.state.arr_data.filter(
      (item) => item.isChecked === true
    );

    console.log("arrayData", arrayData);

    var arr = [];

    for (var i = 0; i < arrayData.length; i++) {
      arr.push(arrayData[i].id);
    }

    const payload = {
      location: this.state.selectedLocation,
      sub_grp_ids: arr,
    };

    API.post("/picking/createpackingTaskData/v1/", { param: payload })
      .then((response) => {
        //alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
          success_message: response.data.message,
          //SuccessConfirmmodal: false
        });
        console.log("response", response.data);
        if (response.data.status === true) {
          this.toggle2();
        } else {
          this.Failedtoggle();
        }
        this.setState({
          SuccessConfirmmodal: false,
          showCreatedId: false,
          showSelectGroup: false,
          showNewGroup: false,
          assignLoader: false,
          assignDisabled: false,
          createDisabled: false,
        });

        this.fetchDispatch();
      })
      .catch(function (error) {});
  }

  UnAssignData() {
    const payload = {
      location: this.state.selectedLocation,
      type: "unassign",
      group_id: this.state.selectedGroup,
      order_id: unassign_arr,
    };

    API.post("/product/product_master/v1/group/unassign/", { param: payload })
      .then((response) => {
        alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
        });

        this.fetchDispatch();
      })
      .catch(function (error) {});
  }

  checkedSingle(index, ischecked, orderid) {
    var arr = [];
    console.log(this.state.binData);
    this.setState({
      loading_overlay: true,
    });
    let newData = this.state.arr_data;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
    }

    console.log(newData);
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),
      //binData: newData,
      arr_data: newData,
    });
  }

  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  toggle1() {
    this.setState((prevState) => ({ modal1: !prevState.modal1 }));
  }

  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    sessionStorage.setItem("PUstore_id", "");
    sessionStorage.setItem("PUpolaris_id", "");
    sessionStorage.setItem("PUstatus_type", "");
    sessionStorage.setItem("PUtask_type_value", "");
    sessionStorage.setItem("PUtask_id", "");

    /* sessionStorage.setItem('store_id', this.state.store_id)
    sessionStorage.setItem('polaris_id', this.state.polaris_id)
    sessionStorage.setItem('status_type', this.state.status_type)
    sessionStorage.setItem('task_type_value', this.state.task_type_value)
    sessionStorage.setItem('task_id', this.state.task_id)
*/

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
        store_id:
          sessionStorage.getItem("store_id") == "null"
            ? ""
            : sessionStorage.getItem("store_id"),
        polaris_id:
          sessionStorage.getItem("polaris_id") == "null"
            ? ""
            : sessionStorage.getItem("polaris_id"),
        task_id:
          sessionStorage.getItem("task_id") == "null"
            ? ""
            : sessionStorage.getItem("task_id"),
        status_type:
          sessionStorage.getItem("status_type") == "null" ||
          sessionStorage.getItem("status_type") == ""
            ? "1"
            : sessionStorage.getItem("status_type"),
        task_type_value:
          sessionStorage.getItem("task_type_value") == "null"
            ? ""
            : sessionStorage.getItem("task_type_value"),
      },
      () => {
        //this.fetchDispatch();
        
      }
    );
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }



  

  createGroup() {
    this.SuccessConfirmtoggle();
  }

  handleChange1 = (e) => {
    this.setState({
      selectedGroup: e.target.value,
    });
  };

  changeSubGroup = (e) => {
    this.setState({
      selectedSubGroup: e.target.value,
    });
  };

  assembleDispatchData = (dispatchData) => {
    
    let DispatchData = dispatchData.map((post, index) => {
      return {
        unique_id: post.unique_id,
        facility_code: post.facility_code,
        ptl_id: post.ptl_id,
        bill_number: post.bill_number,
        retailer_code: post.retailer_code,
        retailer_hul_code: post.retailer_hul_code,
        order_date: post.order_date,
        sequecnce_no: post.sequecnce_no,
        lb_sku_id: post.lb_sku_id,
        base_pack_code: post.base_pack_code,
        cbu_code: post.cbu_code,
        sku7_code: post.sku7_code,
        lb_sku_product_name: post.lb_sku_product_name,
        pkd: post.pkd,
        mrp: post.mrp,
        upc: post.upc,
        loose_ean: post.loose_ean,
        icld_ean: post.icld_ean,
        loose_qty: post.loose_qty,
        icld_qty: post.icld_qty,
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };

  SearchData() {
    console.log("ARR", this.state.arr_data);
    this.setState({
      loading_overlay: true,
    });
    var newArrData = [];
    newArrData = this.state.arr_data.filter(
      (item) =>
        item.party_code == this.state.selectedOutlet ||
        item.distributor_code == this.state.selectedDistributor ||
        item.delivery_center == this.state.selectedLocation ||
        item.outlet_order_no == this.state.selectedOrder
    );

    

    this.setState({
      arr_data: newArrData,
      tableRowsMap: this.assembleDispatchData(newArrData),
    });
  }

  downloadError = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,
      group_id: this.state.selectedGroup,
      station_type: this.state.selectedStation,
    };

    API.post("/product/product_master/v1/task/fetch/", { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("DataVal", data);
        this.setState({
          //showFetchDispatchData: true,
          loading: false,
        });

        window.location.href = data.data[0];
      })
      .catch(function (error) {});
  };

  checkAll() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

     
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data: newData,
        
      });

      
    }
  }

  // downloadError = () => {
  //   //this.setState({loading:true})
  //   const payload = {
  //     report_type: 10,
  //     sub_group: this.state.selectedSubGroup,
  //     download: true,
  //     group_id: this.state.group_id,
  //   };

  //   API.post("/reports/multiReport/v1/", { param: payload })
  //     .then((response) => response.data)
  //     .then((data) => {
        
  //       this.setState({
  //         //showFetchDispatchData: true,
  //         loading: false,
  //       });

  //       window.location.href = data.data[0];
  //     })
  //     .catch(function (error) {});
  // };

  fetchDispatch = (order_no) => {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem("batch_id");
    addAnalytics('Report', 'View Packing Task Report', payload);

    const payload = {
      report_type: 10,
      sub_group: this.state.selectedSubGroup,
      group_id: this.state.group_id,
    };

    API.post("/reports/multiReport/v1/", { param: payload })
      .then((response) => response.data)
      .then((data) => {
        
        this.setState({
          showFetchDispatchData: true,
          loading: false,
        });

        if (data.length == 0) {
          
          this.setState({
            dispatch_status: true,
            showFetchDispatchData: true,
            loading_overlay: false,
            loading: false,
          });
          return false;
        }

        this.setState({
          orderData: data,
          filtered_orderData : data,
          tableRowsMap: this.assembleDispatchData(data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function (error) {});
  };

  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };
    

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2 } = this.state;
    const { SuccessConfirmmodal, Failedmodal } = this.state;

    const dispatchData = {
      columns: [
        {
          label: "Unique Id",

          field: "unique_id",
          width: 120,
        },
        {
          label: "Facility Code",

          field: "facility_code",
          width: 120,
        },
        {
          label: "PTL Id",

          field: "ptl_id",
          width: 120,
        },

        {
          label: "Order Number",

          field: "bill_number",
          width: 220,
        },
        {
          label: "Retailer Code",

          field: "retailer_code",
          width: 120,
        },
        {
          label: "Hul Code",

          field: "retailer_hul_code",
          width: 200,
        },
        {
          label: "Order Date",

          field: "order_date",
          width: 200,
        },
        {
          label: "Sequence No",

          field: "sequecnce_no",
          width: 150,
        },
        {
          label: "jarvis Product Id",

          field: "lb_sku_id",
          width: 200,
        },
        {
          label: "Base Pack Code",

          field: "base_pack_code",
          width: 120,
        },
        {
          label: "Cbu Code",

          field: "cbu_code",
          width: 120,
        },
        {
          label: "SKU7 code",

          field: "sku7_code",
          width: 120,
        },
        {
          label: "Product Name",

          field: "lb_sku_product_name",
          width: 220,
        },
        {
          label: "PKD",

          field: "pkd",
          width: 100,
        },
        {
          label: "MRP",

          field: "mrp",
          width: 100,
        },
        {
          label: "UPC",

          field: "upc",
          width: 100,
        },
        {
          label: "ICLD Ean",

          field: "icld_ean",
          width: 140,
        },

        {
          label: "Loose Ean",

          field: "loose_ean",
          width: 140,
        },
        {
          label: "ICLD Qty",

          field: "icld_qty",
          width: 100,
        },
        {
          label: "Loose Qty",

          field: "loose_qty",
          width: 100,
        },
      ],

      rows: this.state.tableRowsMap,
    };

    return (
       <Col xl={12}>
        {this.state.loading_overlay && <LoadingOverlay active={true} />}
        <Card>
          <Overlay>
            <form className="form" onSubmit={handleSubmit}>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
              </div>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Group</span>
                <div style={{ position: 'relative' }}>
                  <input
                    type="text"
                    style={{ height: 38, borderRadius: "1px solid black" }}
                    className="form-control"
                    placeholder="Enter Group Id"
                    onChange={this.onGroupChange}
                  />
                </div>
              </div>

               <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Sub Group</span>
                <div style={{ position: 'relative' }}>
                  <input
                      type="text"
                      style={{ height: 38, borderRadius: "1px solid black" }}
                      className="form-control"
                      placeholder="Sub Group"
                      onChange={this.changeSubGroup}
                    />
                  {/*<select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.changeSubGroup}
                  >
                    <option value="">Select Sub Group</option>
                    {this.state.subStore.length > 0 &&
                      this.state.subStore.map((subStore) => {
                        return (
                          <option value={subStore.name}>
                            {" "}
                            {subStore.name}
                          </option>
                        );
                      })}
                  </select>*/}
                </div>
              </div>
              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_view"
                    onClick={() => this.fetchDispatch()}
                    >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>

                  <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                    onClick={(e) => exportToCSV(this.state.filtered_orderData, "Packing Task Data Report", Heading)}
                    >
                    <img
                        src={DownloadIcon}
                        alt="Download"
                        style={{ width: '22px' }} // Adjust size as needed
                    />
                    Download
                  </Button>
                </ButtonToolbar>
              </div>
            </form>
          </Overlay>

          {!this.state.showFetchDispatchData && (
            <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
               <img style={{width: '10%'}} src={EmptyDataIcon} />
                <p className="noDataTextStyle">
                Choose your filters from the available options. The data will display
              </p>
              <p className="noDataTextStyle2">
                 here once the filters have been applied.
              </p>
            </div>
          )}

         
          {this.state.showFetchDispatchData && (
            <div>
              <div>
                {this.state.group_id &&
                  <div className="date-container">
                   {this.state.group_id}
                  </div>
                }


                {this.state.selectedSubGroup &&
                  <div className="date-container">
                   {this.state.selectedSubGroup}
                  </div>
                }

              </div>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
                <div
                  className="dispatchData stock_check_data"
                  style={{ marginTop: -27 }}
                >
                  <MDBDataTable
                    scrollX
                    scrollY
                    maxHeight="390px"
                    displayEntries={true}
                    striped
                    bordered
                    onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Packing Task Report', 'datatable_pagination_change' )}
                    onSearch ={this.filterData}
                    data={dispatchData}
                  />
                </div>
              </div>
            </div>

          )}
           
        </Card>

       
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
